export const thisYear = new Date().getFullYear();
export const taxYearOptions = [
  thisYear.toString(),
  (thisYear + 1).toString(),
  (thisYear + 2).toString(),
] as const;
